import { useRef, useCallback } from 'react';

const IDLE_TIMEOUT_MS = 30 * 60 * 1000;

export function useIdleReset(onReset: () => void) {
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const resetIdleTimer = useCallback(() => {
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      onReset();
    }, IDLE_TIMEOUT_MS);
  }, [onReset]);

  const clearIdleTimer = useCallback(() => {
    if (timerRef.current) clearTimeout(timerRef.current);
  }, []);

  return { resetIdleTimer, clearIdleTimer };
}
